/*
 * @author bai <ghimping@alpstein.my>
 * @link https://www.alpstein.my
 * @copyright Copyright (c) Alpstein Software
 *            _____                    _____                    _____
 *           /\    \                  /\    \                  /\    \
 *          /::\    \                /::\    \                /::\    \
 *         /::::\    \              /::::\    \               \:::\    \
 *        /::::::\    \            /::::::\    \               \:::\    \
 *       /:::/\:::\    \          /:::/\:::\    \               \:::\    \
 *      /:::/__\:::\    \        /:::/__\:::\    \               \:::\    \
 *     /::::\   \:::\    \      /::::\   \:::\    \              /::::\    \
 *    /::::::\   \:::\    \    /::::::\   \:::\    \    ____    /::::::\    \
 *   /:::/\:::\   \:::\ ___\  /:::/\:::\   \:::\    \  /\   \  /:::/\:::\    \
 *  /:::/__\:::\   \:::|    |/:::/  \:::\   \:::\____\/::\   \/:::/  \:::\____\
 *  \:::\   \:::\  /:::|____|\::/    \:::\  /:::/    /\:::\  /:::/    \::/    /
 *   \:::\   \:::\/:::/    /  \/____/ \:::\/:::/    /  \:::\/:::/    / \/____/
 *    \:::\   \::::::/    /            \::::::/    /    \::::::/    /
 *     \:::\   \::::/    /              \::::/    /      \::::/____/
 *      \:::\  /:::/    /               /:::/    /        \:::\    \
 *       \:::\/:::/    /               /:::/    /          \:::\    \
 *        \::::::/    /               /:::/    /            \:::\    \
 *         \::::/    /               /:::/    /              \:::\____\
 *          \::/____/                \::/    /                \::/    /
 *           ~~                       \/____/                  \/____/
 *
 */

import React, { Component } from "react";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import PropTypes from "prop-types";
import { WhiteSpace, WingBlank } from "antd-mobile";
import { FaAngleRight } from "react-icons/fa";
import "./index.css";
import StarRatingComponent from "react-star-rating-component";
import Theme from "../../utils/Theme";
import CountdownLabel from "../../components/CountdownLabel";

const StyledContainer = styled.div`
  cursor: pointer;
  margin-top: 1.8em;
  background: white;
  display: flex;
  flex-direction: row;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  border: 1px solid lightgray;
  box-shadow: 0 4px 6px -5px grey;
`;

const StyledProfileLogoContainer = styled.div`
  padding-left: 10px;
  margin-top: -10px;
  width: 44%;
  display: flex;
  flex-direction: column;
`;

const StyledProfileScoreContainer = styled.div`
  padding-bottom: 0.5em;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  font-size: 0.9em;
`;

const StyledProfileScoreLable = styled.div`
  text-align: center;
  color: white;
  background: ${Theme.PrimaryColor};
  padding: 0.9em 1.1em;
  min-width: 1.6em;
`;

const StyledProfileCategoryTitle = styled.div`
  margin-left: 0.8em;
  color: ${Theme.PrimaryColor};
`;

const StyledProfileInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  justify-content: flex-start;
  align-items: flex-start;
  width: 56%;
  padding: 0.5em 0.8em;
`;

const StyledRatingContainer = styled.div`
  font-size: 0.8em;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
`;

const StyledTitle = styled.span`
  text-align: start;
  width: 100%;
  font-weight: bold;
  color: black;
  line-height: 1.6;
  font-size: 0.9em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledMultiLineDescription = styled.span`
  color: grey;
  text-align: start;
  display: block;
  display: -webkit-box;
  width: 100%;
  max-width: 100%;
  height: 3.4em;
  margin: 0 auto;
  font-size: 0.8em;
  line-height: 1.2;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledWaitingTimeContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  align-self: flex-end;
`;

const StyledShopClosed = styled.div`
  color: #fff;
  background: red;
  font-weight: bold;
  padding: 3px;
  font-size: 0.8em;
  border-radius: 2px;
`;

class StallItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      fade: false
    };
  }

  onItemClicked = () => {
    const { onItemClicked } = this.props;

    if (onItemClicked) {
      onItemClicked();
    }

    this.setState({ fade: true });
  };

  render() {
    const {
      title,
      code,
      description,
      review,
      imageSrc,
      categoryTitle,
      waitingTime,
      isAvailable
    } = this.props;
    const { fade } = this.state;
    return (
      <StyledContainer
        className={fade ? "fade" : ""}
        onAnimationEnd={() => this.setState({ fade: false })}
        onClick={() => this.onItemClicked()}
      >
        <StyledProfileLogoContainer>
          <img
            ref={ref => (this.itemImage = ref)}
            src={imageSrc}
            alt=""
            style={{
              maxWidth: "100%",
              maxHeight: "100%",
              width: "100%",
              minHeight: "3em"
            }}
            onLoad={() => {
              window.dispatchEvent(new Event("resize"));
            }}
          />
          <StyledProfileScoreContainer>
            <StyledProfileScoreContainer>
              <StyledProfileScoreLable>{code}</StyledProfileScoreLable>
              <StyledProfileCategoryTitle>
                {categoryTitle}
              </StyledProfileCategoryTitle>
            </StyledProfileScoreContainer>
          </StyledProfileScoreContainer>
        </StyledProfileLogoContainer>
        <StyledProfileInfoContainer>
          <StyledTitle>{title}</StyledTitle>
          <StyledMultiLineDescription>{description}</StyledMultiLineDescription>
          <WhiteSpace size={"sm"} />
          <StyledRatingContainer>
            <StarRatingComponent
              name={"stallItemRating"}
              editing={false}
              starCount={5}
              value={review}
              starColor={Theme.PrimaryColor}
              emptyStarColor={"lightgrey"}
            />
            {isAvailable ? null : (
              <StyledShopClosed>
                <FormattedMessage
                  id="stall.list.close"
                  defaultMessage="Closed"
                  description="Stall is Closed"
                />
              </StyledShopClosed>
            )}
          </StyledRatingContainer>
          <WhiteSpace size={"lg"} />
          <StyledWaitingTimeContainer>
            {waitingTime ? <CountdownLabel title={waitingTime} /> : null}
            <WingBlank size={"sm"} />
            <FaAngleRight size={"1.2em"} color={"grey"} />
          </StyledWaitingTimeContainer>
        </StyledProfileInfoContainer>
      </StyledContainer>
    );
  }
}

StallItem.propTypes = {
  onItemClicked: PropTypes.func,
  imageSrc: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  description: PropTypes.string,
  review: PropTypes.number,
  categoryTitle: PropTypes.string,
  waitingTime: PropTypes.string,
  isAvailable: PropTypes.bool
};

StallItem.defaultProps = {
  title: "",
  code: "",
  description: "",
  imageSrc: "https://via.placeholder.com/400x300",
  review: 0,
  categoryTitle: "",
  waitingTime: ""
};

export default StallItem;



// WEBPACK FOOTER //
// ./src/components/StallItem/index.js